import React from 'react';
import { motion } from 'framer-motion';
import Header from '../header';
import { Container, HeaderContainer, StepContainer } from './step.styles';
import { ResponsiveWrapper, ChartBase } from '../../../../components';
import { calculateStepPoints } from '../../utils';
var createStepMotion = function (layout) {
    var _a, _b;
    var motionProperty = layout === 'horizontal' ? 'x' : 'y';
    return {
        hidden: (_a = {
                opacity: 0
            },
            _a[motionProperty] = -100,
            _a),
        visible: (_b = {
                opacity: 1
            },
            _b[motionProperty] = 0,
            _b),
    };
};
var createStepTransition = function (idx) { return ({
    delay: idx * 0.2,
    duration: 0.7,
}); };
var stepShadow = '10px 20px 24px 8px rgba(29,39,41, .1)';
export var FunnelStep = function (_a) {
    var index = _a.index, label = _a.label, stepsCount = _a.stepsCount, value = _a.value, percentageValue = _a.percentageValue, nextPercentageValue = _a.nextPercentageValue, scale = _a.scale, color = _a.color, margins = _a.margins, theme = _a.theme, layout = _a.layout;
    var stepMotion = createStepMotion(layout);
    var _b = theme.funnel, step = _b.step, header = _b.header;
    return (React.createElement(StepContainer, { layout: layout, stepsCount: stepsCount, "data-testid": "funnel-step" },
        React.createElement(motion.div, { style: { width: '100%', height: '100%' }, transition: { duration: 0.3, ease: 'easeOut' }, whileHover: {
                scale: 1.05,
                boxShadow: stepShadow,
            } },
            React.createElement(Container, { layout: layout, backgroundColor: step.backgroundColor },
                React.createElement(HeaderContainer, { centerItems: layout === 'horizontal', fixedWidth: layout === 'vertical', backgroundColor: header.backgroundColor },
                    React.createElement(Header, { label: label, value: value, flipBadge: layout === 'horizontal', percentageValue: percentageValue, theme: theme })),
                React.createElement(ResponsiveWrapper, null, function (width, height) {
                    var path = calculateStepPoints({
                        layout: layout,
                        scale: scale,
                        percentageValue: percentageValue,
                        nextPercentageValue: nextPercentageValue,
                        dimension: { height: height, width: width },
                        margins: margins,
                    });
                    return (React.createElement(ChartBase, { svgDimensions: { width: width, height: height }, margins: margins, theme: theme },
                        React.createElement(motion.path, { fill: color, d: path, transition: createStepTransition(index), initial: "hidden", animate: "visible", variants: stepMotion })));
                })))));
};
export default FunnelStep;
